import { useTrackingEvents } from '~/composables/tracking-events/use-tracking-events'
import { useRegisterAddonStore } from '@kira-dancer/nuxt-common/stores'
import { TrackingEventName } from '~/enums'
import { useUserStore } from '#lib/stores'
import type { SignUpInitiated, SignUpCompleted } from '~/types/tracking-events'

export function useUserOnboardingEvents() {
  const { trackingEvents } = useTrackingEvents()
  const { queries } = useRegisterAddonStore()
  const userStore = useUserStore()

  const signUpInitiated = () => {
    const userId = userStore.data.id
    const gaValue = useCookie('_ga').value as string

    const params: SignUpInitiated = {
      user_id: userId || gaValue,
      referral_source: queries.utm_source,
    }
    trackingEvents(TrackingEventName.SignUpInitiated, params)
  }

  const signUpCompleted = () => {
    const userId = userStore.data.id
    const gaValue = useCookie('_ga').value as string

    const params: SignUpCompleted = {
      user_id: userId || gaValue,
    }
    trackingEvents(TrackingEventName.SignUpCompleted, params)
  }

  return {
    signUpInitiated,
    signUpCompleted,
  }
}
